import type { Notification } from '../hooks/useNotifications';

interface NotificationsProps {
  notifications: Notification[];
  onDismiss: (id: string) => void;
}

const typeStyles = {
  success: 'bg-green-500 dark:bg-green-600',
  error: 'bg-red-500 dark:bg-red-600',
  info: 'bg-telegram-blue dark:bg-telegram-blue-dark',
} as const;

const typeIcons = {
  success: '\u2713',
  error: '\u2715',
  info: '\u2139',
} as const;

export function Notifications({
  notifications,
  onDismiss,
}: NotificationsProps): React.JSX.Element | null {
  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="fixed right-4 top-4 z-50 flex flex-col gap-2">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`flex items-center gap-2 rounded-lg px-4 py-2 text-white shadow-lg ${typeStyles[notification.type]}`}
          role="alert"
        >
          <span className="text-lg">{typeIcons[notification.type]}</span>
          <span className="text-sm">{notification.message}</span>
          <button
            onClick={() => onDismiss(notification.id)}
            className="ml-2 opacity-70 hover:opacity-100"
            aria-label="Dismiss"
          >
            {'\u2715'}
          </button>
        </div>
      ))}
    </div>
  );
}
